import { ICountryBeneficiaries } from "@interfaces/screens/beneficiaries.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import DataGrid, { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { useSelector } from 'react-redux';
import { IProaService, ProaService} from "@services/proyecta/proa-form.service";
import { Utilities, Enums, Constants, queryString, Dictionary } from "@utils";
import {IBudgetFormBasicDataMasters, IPProaBeneficiariosDuplicados, ILang  } from "@models/*";

export class CountryBeneficiariesPresenter extends BasePresenter<ICountryBeneficiaries> {
  public currentLang: ILang;
  private _service: IProaService;
  public formMasters: IBudgetFormBasicDataMasters;
  public BudgetsData: any;
  private _tableId: string = 'country-beneficiaries';
  private _tableIdTemplate: string = 'country-details';
  public summaryConfigDup: Array<any>;
  public summaryConfig: Array<any>;
  public _viewMode: boolean = false;
  public currentLabels: Dictionary<string, string>;
  public country: string;
  public year: string;
  public params: any;

  constructor(view: ICountryBeneficiaries) {
    super(view);
    this._service = new ProaService();
    this._viewMode = window.location.href.includes("view");
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
    this.BudgetsData = useSelector(this.context.proaStore.selectBudgetsData);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this.params = useSelector(this.context.sessionStore.selectParams);
    this.getSummary();
    let dataQuery = this.getQueries();
    this.country = dataQuery.Country;
    this.year = dataQuery.Year;
    this.onChangeCellValue = this.onChangeCellValue.bind(this);
  }

  private getQueries() {
    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    return query;
  }

  public async initialize() {
    this.dispatcherProgress(0);
    this.dispatcher(this.context.proaStore.getAllFormMasters());
    this.dispatcher(this.context.proaStore.getProaBudget());
    this.dispatcherProgress(50);
  }

  public getSummary() {
    this.summaryConfig = [
      { column: "project", summaryType: 'custom', displayFormat:this.currentLabels.get("TotalesDupPais"), name: "notValue" }, 
      { column: "project", summaryType: 'custom', displayFormat:this.currentLabels.get("TotalesPais"), name: "notValue" },
      { column: "beneficiaries", summaryType: 'custom', name:"beneficiariesDuplicate", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "PFFRRTotalHombres", summaryType: 'custom', name:"PFFRRTotalHombresDuplicate", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "PFFRRTotalHombres", summaryType: 'custom', name:"PFFRRTotalHombres", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "PFRRTotalMujeres", summaryType: 'custom', name:"PFRRTotalMujeresDuplicate", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "PFRRTotalMujeres", summaryType: 'custom', name:"PFRRTotalMujeres", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "totalDup", summaryType: 'custom', name:"totalDup", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "total", summaryType: 'custom', name:"notValue", displayFormat:"-", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "total", summaryType: 'custom', name:"total", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
    ]
  }

  public async initReport(){  
    let searchId: number = null;
    let field: string = null;
    let dataSource: any[] = [];
    let auxData: any[] = [];

    searchId = this.formMasters.regions.find((x: any) => (this.country == x.Title || this.country == x.OCTAVIANombreEn || this.country == x.OCTAVIANombreFR ||  this.country == x.OCTAVIANombrePT))?.Id
    if(searchId) field = "OCTAVIARegion";
    else {
      searchId = this.formMasters.countries.find((x: any) => (this.country == x.Title || this.country == x.OCTAVIANombreEn || this.country == x.OCTAVIANombreFR ||  this.country == x.OCTAVIANombrePT))?.Id
      field = "OCTAVIAPais";
    }

    let projectDuplicates = await this._service.getAllBeneficiariesDuplicates();
    this.dispatcherProgress(70);
    let duplicatesSP = await this._service.getCountryBeneficiariesDuplicates(searchId, field); 
    this.dispatcherProgress(90);

    let dataIds: number[] = [];
    this.BudgetsData.forEach((budget: any) => {
      if(budget[`${field}Id`] == searchId && budget.PPresAnio?.Title == this.year){
        dataIds.push(budget.Id)
        dataSource.push(budget)
        if(budget.PPresPresupuestoId){
          let child = this.BudgetsData.find((bud: any) => bud.Id === budget.PPresPresupuestoId)
          if(child) dataIds.push(child.Id)
        }
      }
    });

    let basicData = await this._service.getBeneficiariesAnio(dataIds, this.year);
    this.dispatcherProgress(95);

    dataSource.forEach((data: any) => {
      let beneficiariesAnios = basicData.filter((basic: any) => (basic.PPresPresupuestoId === data.Id || basic.PPresPresupuestoId === data.PPresPresupuestoId));
      let duplicatesProject = projectDuplicates.filter((dup: any) => ((dup.PPresPresupuestoId === data.Id || dup.PPresPresupuestoId === data.PPresPresupuestoId) && dup.PPresuAnio == this.year));

      if(beneficiariesAnios.length){
        let sumDuplicados = 0;
        let sumMens = 0;
        let sumWomens = 0;
        let sumMensDup = 0;
        let sumWomenDup = 0;

        beneficiariesAnios.forEach((benefAnio: any ) => {
          sumMens += (benefAnio.PFFRRTotalHombres || 0)
          sumWomens += (benefAnio.PFRRTotalMujeres || 0)
        });
        if(sumMens + sumWomens){
          duplicatesProject.forEach((dupProject: any )=> {
            sumMensDup += (dupProject.PFFRRTotalHombres || 0)
            sumWomenDup += (dupProject.PFRRTotalMujeres || 0)
          });

          let dupFindSP = duplicatesSP.filter((dupSP: any) => (dupSP.PresupuestoPadreId === data.Id && dupSP.PPresuAnio == this.year))

          dupFindSP.forEach((dup: any )=> {sumDuplicados = sumDuplicados + (dup.PFFRRTotalHombres || 0) + (dup.PFRRTotalMujeres || 0)});
          let beneficiarios = ((sumMens + sumWomens) - (sumMensDup + sumWomenDup)) || 0;

          let objData: any = {
            ID: data.Id,
            project: data.CodigoProyecto?.Title,
            beneficiaries: beneficiarios || null,
            PFFRRTotalHombres: (sumMens - sumMensDup) || null,
            PFRRTotalMujeres: (sumWomens - sumWomenDup) || null,
            totalDup: sumDuplicados,
            total: (beneficiarios - sumDuplicados),
            [`${field}Id`]: searchId,
            year: this.year,
            PPresNumProy: data.PPresNumProy
          }

          auxData.push(objData)
        }
      }
    });

    auxData = auxData.sort((a, b) => ((a.PPresNumProy < b.PPresNumProy) ? -1 : ((a.PPresNumProy > b.PPresNumProy) ? 1 : 0)));

    let columns = this.getReportColumns(this.year);
    this.view.state.setDataColumns(columns);
    this.view.state.setDataSource(auxData);
    this.view.state.setDuplicatesSP(duplicatesSP);
    this.dispatcherProgress(100);
    this.dispatcherUnsetSetLoading();
  }

  public getDataDetails = (detail: any) =>{
    let dataSource = Utilities.copyObject(this.view.state.dataSource);
    let dataDetail: any[] = [];
    let auxData: any[] = [];
    let pivot: any = null;

    dataSource.map((dup:any )=> {
      if(pivot) auxData.push(dup) 
      if(dup.ID === detail.ID) pivot = dup
    })

    auxData.forEach(data => {
      let duplicatesObj: any = {
        ID: data.ID,
        project: data.project,
        PresupuestoPadreId: pivot.ID
      }
      let dupFind = this.view.state.duplicatesSP.find((dupSp: any) => (dupSp.PresupuestoPadreId === pivot.ID && dupSp.PPresuAnio == data.year && data.ID === dupSp.PPresPresupuestoId))
      
      duplicatesObj.PFFRRTotalHombres =  dupFind ? dupFind.PFFRRTotalHombres : null;
      duplicatesObj.PFRRTotalMujeres =  dupFind ? dupFind.PFRRTotalMujeres : null;
      dataDetail.push(duplicatesObj)
    })
    return {dataSource: dataDetail, columns: this.getReportDetailColumns()};
  }

  public validateCell = (e: any, pivot: any, dataDetail: any) => {

    let myData = this.view.state.dataSource.find((aux: any) => aux.ID === e.data.ID)
    let result: boolean = (e.value <= (pivot[e.column.dataField] || 0) && e.value <= (myData[e.column.dataField] || 0))

    return result;
  };

  public async saveData(dataSource: any) {
    let saveObjects: any[] = [];

    dataSource.forEach(async (data: any) => {
      let tableID = `${this._tableIdTemplate}-${data.ID}`;
      let duplicates = this.getDataSourceFromTable(tableID);
      let field = data.OCTAVIAPaisId ? "OCTAVIAPaisId" : "OCTAVIARegionId";
      let duplicatesSP = await this._service.getCountryBeneficiariesDuplicates(data[field], field);

      duplicates.forEach((overDup: any) => {
      let elementSP = duplicatesSP.find((dupSp:any) => (dupSp.PresupuestoPadreId === data.ID && dupSp.PPresuAnio == data.year && overDup.ID === dupSp.PPresPresupuestoId))?.Id

        let DuplicateMens = (overDup.PFFRRTotalHombres || 0)
        let DuplicateWomens = (overDup.PFRRTotalMujeres || 0)
        let item: IPProaBeneficiariosDuplicados = {
          PPresPresupuestoId: overDup.ID,
          PFFRRTotal: (DuplicateMens + DuplicateWomens) || null,
          PFFRRTotalHombres: DuplicateMens || null,
          PFRRTotalMujeres: DuplicateWomens || null,
          PPresuAnio: data.year,
          PresupuestoPadreId: data.ID,
          [field]: data[field]
        }

        if(elementSP) item.Id = elementSP
        if((DuplicateMens || DuplicateWomens) || elementSP) saveObjects.push(item)
      });
      
    });

    this._service.saveCountryDuplicate(saveObjects, this.currentUser.currentUser.userPrincipalName, Enums.ListTypes.PProaBeneficiariosDuplicadosPais);

    const title = this.currentLabels.get("Guardar");
    const msg = this.currentLabels.get("Guardado exitoso");
    Utilities.notifySuccess(msg, title);
  }

  public saveDetail = async (duplicates: any, pivot: any) => {
    let stateDuplicates = this.view.state.duplicatesSP;
    let masterData = Utilities.copyObject(this.view.state.dataSource);
    let saveObjects: any[] = [];

    masterData.forEach((data: any) => {
      if(data.ID === pivot.ID){
        let sumDuplicados = 0;
        duplicates.forEach((overDup: any) => {
          let DuplicateMens = (overDup.PFFRRTotalHombres || 0)
          let DuplicateWomens = (overDup.PFRRTotalMujeres || 0)
          sumDuplicados += (DuplicateMens + DuplicateWomens)

          let item: IPProaBeneficiariosDuplicados = {
            PPresPresupuestoId: overDup.ID,
            PFFRRTotal: (DuplicateMens + DuplicateWomens) || null,
            PFFRRTotalHombres: DuplicateMens || null,
            PFRRTotalMujeres: DuplicateWomens || null,
            PPresuAnio: data.year,
            PresupuestoPadreId: pivot.ID,
          }

          saveObjects.push(item)
        });
        data.total = ((data.beneficiaries || 0) - sumDuplicados)
        data.totalDup = sumDuplicados || null
      }
      return data;
    });

    let newDuplicatesSP = stateDuplicates.map(dupSp => {
      let objFind = saveObjects.find(auxObj => (dupSp.PresupuestoPadreId === auxObj.PresupuestoPadreId && dupSp.PPresuAnio == auxObj.PPresuAnio && auxObj.PPresPresupuestoId === dupSp.PPresPresupuestoId))
      return objFind ? objFind : dupSp;
    })
    saveObjects.map(auxObj => {
      let objFind = newDuplicatesSP.find(dupSp => (auxObj.PresupuestoPadreId === dupSp.PresupuestoPadreId && auxObj.PPresuAnio == dupSp.PPresuAnio && auxObj.PPresPresupuestoId === dupSp.PPresPresupuestoId))
      if(!objFind) newDuplicatesSP.push(auxObj)
    })

    this.view.state.setDataSource(masterData);
    this.view.state.setDuplicatesSP(newDuplicatesSP);
  }

  public getGridProps() {
    let internalProps: any = {
      id: this._tableId,
      showRowLines: true,
      columnMinWidth: 200,
      stateStoring: {
        enabled: true,
        type: "localStorage",
        storageKey: "storage_" + this._tableId
      },
      allowColumnResizing: true,
      columnResizingMode: "widget",
      wordWrapEnabled: true,
      columnFixing: { enabled: true },
    };

    internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

    let onToolbarPreparing = (e: any) => {  };

    return { ...internalProps };
  }

  public getGridPropsDetails(pivot: any) {
    let internalProps: any = {
      id: `${this._tableIdTemplate}-${pivot.ID}`,
      showRowLines: true,
      editing: { mode: "cell", allowUpdating: true, allowAdding: false, allowDeleting: false, useIcons: true },
      stateStoring: {
        enabled: false,
        type: "localStorage",
        storageKey: "storage_" + this._tableIdTemplate
      },
      allowColumnResizing: true,
      columnResizingMode: "widget",
      wordWrapEnabled: true,
      loadPanel: {
        enabled:"auto",
        showIndicator:false,
        showPane:false,
        text: ""
      },
    };

    internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

    let onToolbarPreparing = (e: any) => {  };

    return { ...internalProps };
  }

  private getDataFromTable(tableId: string): DataGrid {
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return null;
    }

    return DataGrid.getInstance(element) as DataGrid;
  }

  private getDataSourceFromTable(tableId: string): Array<any> {
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return [];
    }

    let instance = DataGrid.getInstance(element) as DataGrid;
      return instance.getDataSource().items();
  }

  private onChangeCellValue(event: any) {
        if (event && event.value) {

        }
    }

  private getReportColumns(year: string) {
    return <dxDataGridColumn[]>[
      {
        caption: this.currentLabels.get("Proyecto"),
        dataField: 'project',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        fixed: true,
        fixedPosition: "left",
      },
      {
        caption: `${this.currentLabels.get("SupBeneficiariosPais")} ${year}`,
        dataField: 'beneficiaries',
        visible: true,
        dataType: 'number',
        alignment: 'center'
      },
      {
        caption: `${this.currentLabels.get("BeneficiariosHombres")} ${year}`,
        dataField: 'PFFRRTotalHombres',
        visible: true,
        dataType: 'number',
        alignment: 'center'
      },
      {
        caption: `${this.currentLabels.get("BeneficiariosMujeres")} ${year}`,
        dataField: 'PFRRTotalMujeres',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
      {
        caption: `${this.currentLabels.get("BeneficiariosTotalDup")} ${year}`,
        dataField: 'totalDup',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
      {
        caption: `${this.currentLabels.get("BeneficiariosTotalPais")} ${year}`,
        dataField: 'total',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
    ];
  }

  private getReportDetailColumns() {
    let hasPermission = this.getTotalPermissions()
    return <any[]>[
      {
        caption: this.currentLabels.get("Proyecto"),
        dataField: 'project',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        readOnly: true,
        fixed: true,
        fixedPosition: "left",
      },
      {
        caption: this.currentLabels.get("BeneficiariosHombres"),
        dataField: 'PFFRRTotalHombres',
        visible: true,
        dataType: 'number',
        alignment: 'center',
        validateDuplicates: true,
        validationErrorMessage: this.currentLabels.get("DuplicatesErrorMessage"),
        readOnly: hasPermission ? this._viewMode : true
      },
      {
        caption: this.currentLabels.get("BeneficiariosMujeres"),
        dataField: 'PFRRTotalMujeres',
        visible: true,
        dataType: 'number',
        alignment: 'center',
        validateDuplicates: true,
        validationErrorMessage: this.currentLabels.get("DuplicatesErrorMessage"),
        readOnly: hasPermission ? this._viewMode : true
      }
    ];
  }

  public getTotalPermissions(){
    const TEAM_CENTRAL = this.params[Enums.Params.proyectaCentralTeam]
    const ADMIN_GROUP = this.params[Enums.Params.proyectaAdminModule]
    let countryRegionGroup: string = [...this.formMasters?.countries, ...this.formMasters?.regions]?.find((cr: any) => cr.Title === this.country)?.SGGrupoAD
    let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
    let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)
    
    return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
  }
   
}
